'use strict';

var React = require('react');

const colToColSize = (col, colSize) => {
    const colKey = col.id.split('-').pop();
    if (colKey) {
        return { ...colSize, [colKey]: col.style.width };
    }
    return colSize;
};
function useResize(id, columns) {
    const [resize, setResize] = React.useState({
        pageX: undefined,
        curCol: undefined,
        curColWidth: undefined,
        nxtCol: undefined,
        nxtColWidth: undefined,
    });
    const [colSize, setColSize] = React.useState({
        ...columns.reduce((acc, c) => {
            acc[c.key] = c.width || 'auto';
            return acc;
        }, {}),
    });
    React.useEffect(() => {
        setColSize({
            ...colSize,
            ...columns.reduce((acc, c) => {
                acc[c.key] = c.width || 'auto';
                return acc;
            }, {}),
        });
    }, [columns]);
    const resizeMouseDown = (key) => (e) => {
        const curResize = {
            pageX: undefined,
            curCol: undefined,
            curColWidth: undefined,
            nxtCol: undefined,
            nxtColWidth: undefined,
        };
        let parent = e.target.parentElement;
        while (parent && parent.tagName !== 'TH' && parent.tagName !== 'TD') {
            parent = parent.parentElement;
        }
        if (parent) {
            const nxtParent = parent.nextElementSibling;
            curResize.curColWidth = parent.offsetWidth;
            curResize.pageX = e.pageX;
            curResize.curCol = document.getElementById(`${id}-col-${key}`);
            curResize.nxtCol = curResize.curCol.nextElementSibling;
            if (curResize.nxtCol && nxtParent) {
                curResize.nxtColWidth = nxtParent.offsetWidth;
            }
            setResize(curResize);
        }
    };
    const resizeMouseMove = (e) => {
        if (resize.curCol && resize.curColWidth && resize.pageX) {
            e.stopPropagation();
            e.preventDefault();
            const diffX = e.pageX - resize.pageX;
            if (resize.curColWidth + diffX < 20 || (resize.nxtCol && resize.nxtColWidth && resize.nxtColWidth - diffX < 20)) {
                return;
            }
            resize.curCol.style.width = resize.curColWidth + diffX + 'px';
            if (resize.nxtCol && resize.nxtColWidth) {
                resize.nxtCol.style.width = resize.nxtColWidth - diffX + 'px';
            }
        }
    };
    const resizeMouseUp = () => {
        if (resize.curCol) {
            let curColSize = colToColSize(resize.curCol, colSize);
            if (resize.nxtCol) {
                curColSize = colToColSize(resize.nxtCol, curColSize);
            }
            setColSize(curColSize);
            setResize({
                pageX: undefined,
                curCol: undefined,
                curColWidth: undefined,
                nxtCol: undefined,
                nxtColWidth: undefined,
            });
        }
    };
    React.useEffect(() => {
        document.addEventListener('mousemove', resizeMouseMove);
        document.addEventListener('mouseup', resizeMouseUp);
        return () => {
            document.removeEventListener('mousemove', resizeMouseMove);
            document.removeEventListener('mouseup', resizeMouseUp);
        };
    }, [resizeMouseMove, resizeMouseUp]);
    return { colSize, setColSize, resizeMouseDown };
}

exports.useResize = useResize;
//# sourceMappingURL=useResize.js.map
